<template>
  <ResourceForm
    :type="type"
    @close="$emit('close')"
    @created="$emit('created', $event)"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ResourceForm from './resource-form/index.vue';

export default defineComponent({
  components: {
    ResourceForm,
  },
  props: {
    type: {
      type: String,
      validator: (value) => !value || ['room', 'equipment'].includes(value),
    },
  },
  emits: ['close', 'created'],
});
</script>
